const base = "/security";
const path = {
  mySecurityStatus: `${base}/answers/my-security-status`,
  randomQuestion: `${base}/questions/random`,
  saveQuestion: `${base}/answers`,
  validateAnswer: `${base}/answers/validate`,
  myQuestions: `${base}/questions/my-questions`,
};
export { path };
